<template>
  <svg
    width="71"
    height="52"
    viewBox="0 0 71 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="71" height="52" fill="white" />
    <path
      opacity="0.8"
      d="M36.5459 3.54199C49.0497 3.54205 59.1865 13.6788 59.1865 26.1826C59.1864 38.6864 49.0497 48.8222 36.5459 48.8223C24.0421 48.8223 13.9054 38.6864 13.9053 26.1826C13.9053 13.6787 24.042 3.54199 36.5459 3.54199ZM65.8877 15.4961C66.9879 15.4961 67.8798 16.3881 67.8799 17.4883C67.8799 18.5886 66.988 19.4804 65.8877 19.4805C64.7874 19.4805 63.8955 18.5886 63.8955 17.4883C63.8956 16.388 64.7874 15.4961 65.8877 15.4961ZM7.92871 1.00586C10.0291 1.006 11.7322 2.70916 11.7324 4.80957C11.7324 6.91014 10.0292 8.61314 7.92871 8.61328C5.82806 8.61328 4.125 6.91022 4.125 4.80957C4.12519 2.70908 5.82817 1.00586 7.92871 1.00586Z"
      fill="url(#paint0_radial_410_32617)"
    />
    <path
      d="M21.5352 16.2755C21.5352 14.9023 22.6484 13.7891 24.0216 13.7891L29.5516 13.7891C30.0867 13.7891 30.596 14.0189 30.95 14.4201L32.1675 15.7999C32.5215 16.2011 33.0307 16.4309 33.5658 16.4309H44.8457C46.219 16.4309 47.3322 17.5442 47.3322 18.9174V36.7888C47.3322 37.4755 46.7756 38.0321 46.089 38.0321H22.7784C22.0918 38.0321 21.5352 37.4755 21.5352 36.7888L21.5352 16.2755Z"
      fill="url(#paint1_radial_410_32617)"
    />
    <g opacity="0.5" filter="url(#filter0_f_410_32617)">
      <rect
        width="22.1878"
        height="19.0839"
        rx="1.24323"
        transform="matrix(0.96964 -0.222888 0.29612 0.947278 21.6406 20.9961)"
        fill="url(#paint2_radial_410_32617)"
      />
    </g>
    <path
      d="M27.7779 36.9879C27.6596 36.6347 27.7134 36.2649 27.9241 35.9824L42.5089 16.4262C42.6677 16.2133 42.9045 16.065 43.18 16.0059L47.2288 15.1372C47.896 14.994 48.6118 15.4002 48.8276 16.0445L54.1077 31.8082C54.3235 32.4525 53.9576 33.0909 53.2905 33.234L29.5236 38.3338C28.8564 38.477 28.1406 38.0707 27.9248 37.4264L27.7779 36.9879Z"
      fill="url(#paint3_radial_410_32617)"
    />
    <path
      d="M53.9615 31.3707C53.8432 31.0175 53.5656 30.7189 53.2065 30.5585L28.3552 19.4645C28.0847 19.3437 27.787 19.3101 27.5114 19.3692L23.4627 20.238C22.7955 20.3811 22.4296 21.0195 22.6454 21.6638L27.9256 37.4275C28.1414 38.0718 28.8572 38.478 29.5243 38.3349L53.2912 33.2351C53.9583 33.0919 54.3242 32.4535 54.1084 31.8093L53.9615 31.3707Z"
      fill="url(#paint4_radial_410_32617)"
    />
    <g opacity="0.5" filter="url(#filter1_f_410_32617)">
      <path
        d="M36.2731 19.1663L24.3493 22.1234C23.2615 22.3931 23.1207 23.8369 24.1308 24.3647L31.8538 28.4004C32.1326 28.5461 32.4542 28.5856 32.7544 28.5112L44.8428 25.5133L49.5988 18.0488C50.1878 17.1245 49.2847 15.9395 48.1969 16.2093L36.2731 19.1663Z"
        fill="url(#paint5_radial_410_32617)"
      />
    </g>
    <g opacity="0.5" filter="url(#filter2_f_410_32617)">
      <path
        d="M40.4964 34.279L52.4202 31.322C53.508 31.0522 53.6488 29.6084 52.6388 29.0806L44.9157 25.0449C44.6369 24.8992 44.3154 24.8597 44.0151 24.9342L31.9267 27.932L27.1707 35.3965C26.5818 36.3208 27.4848 37.5058 28.5727 37.236L40.4964 34.279Z"
        fill="url(#paint6_radial_410_32617)"
      />
    </g>
    <path
      d="M41.3231 35.8002L53.5707 33.1458C54.622 32.9179 54.7696 31.5897 53.8096 30.9961L37.295 20.7852C36.6504 20.3866 35.8306 20.5643 35.519 21.1701L27.5383 36.6897C27.0744 37.5919 28.0242 38.6824 29.0755 38.4545L41.3231 35.8002Z"
      fill="url(#paint7_radial_410_32617)"
    />
    <path
      d="M35.4542 17.6432L23.2066 20.2976C22.1553 20.5254 22.0077 21.8536 22.9678 22.4472L39.4823 32.6581C40.127 33.0567 40.9468 32.879 41.2583 32.2732L49.239 16.7536C49.7029 15.8514 48.7532 14.761 47.7019 14.9889L35.4542 17.6432Z"
      fill="url(#paint8_radial_410_32617)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M42.7542 13.709C42.4556 13.7739 42.1436 13.9724 41.8973 14.399L38.9813 19.4496C38.8984 19.5932 38.9026 19.7413 38.9942 19.9103C39.0925 20.0917 39.2861 20.2769 39.5341 20.4157C39.7818 20.5543 40.0456 20.6252 40.2579 20.6182C40.4613 20.6114 40.5851 20.5386 40.6557 20.4163L42.5059 17.2116C42.5695 17.1016 42.5655 17.0216 42.5478 16.9669C42.5274 16.904 42.4774 16.841 42.4029 16.798C42.3284 16.755 42.2488 16.7431 42.1842 16.7569C42.1279 16.769 42.0566 16.8055 41.9931 16.9155L40.5741 19.3733C40.4725 19.5493 40.2473 19.6097 40.0713 19.508C39.8952 19.4064 39.8349 19.1812 39.9365 19.0051L41.3555 16.5474C41.5169 16.2679 41.7582 16.0952 42.03 16.037C42.2936 15.9806 42.5579 16.0374 42.771 16.1604C42.9841 16.2834 43.1654 16.4839 43.2483 16.7404C43.3338 17.0049 43.3049 17.3002 43.1435 17.5797L41.2933 20.7844C41.0634 21.1827 40.6683 21.3411 40.2824 21.354C39.9054 21.3666 39.5094 21.2455 39.1746 21.0581C38.8401 20.871 38.5286 20.5962 38.347 20.2612C38.1587 19.9139 38.1083 19.4893 38.3437 19.0815L41.2597 14.0309C41.5989 13.4433 42.0762 13.1029 42.5978 12.9895C43.1116 12.8779 43.6324 12.9943 44.0566 13.2509C44.9063 13.7649 45.4353 14.897 44.7665 16.0556L44.5332 16.4303L43.7561 16.4303L44.1289 15.6874C44.5635 14.9347 44.2434 14.2243 43.6755 13.8808C43.3908 13.7086 43.0606 13.6424 42.7542 13.709Z"
      fill="url(#paint9_radial_410_32617)"
    />
    <defs>
      <filter
        id="filter0_f_410_32617"
        x="20.7099"
        y="15.0517"
        width="29.0255"
        height="25.0216"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="0.621616"
          result="effect1_foregroundBlur_410_32617"
        />
      </filter>
      <filter
        id="filter1_f_410_32617"
        x="22.206"
        y="14.9267"
        width="28.8224"
        height="14.8654"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="0.621616"
          result="effect1_foregroundBlur_410_32617"
        />
      </filter>
      <filter
        id="filter2_f_410_32617"
        x="25.7411"
        y="23.6533"
        width="28.8224"
        height="14.8654"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="0.621616"
          result="effect1_foregroundBlur_410_32617"
        />
      </filter>
      <radialGradient
        id="paint0_radial_410_32617"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(57.0282 -11.6071) rotate(119.736) scale(75.6638 84.0128)"
      >
        <stop stop-color="#EAEEF9" />
        <stop offset="1" stop-color="#A3B1D1" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_410_32617"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(53.6023 43.7445) rotate(-136.685) scale(44.0727 49.0742)"
      >
        <stop stop-color="#EDF0F6" />
        <stop offset="1" stop-color="#FAFBFD" />
      </radialGradient>
      <radialGradient
        id="paint2_radial_410_32617"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(11.238 6.78889) rotate(89.1049) scale(36.8908 42.2959)"
      >
        <stop stop-color="#A3B1D1" />
        <stop offset="0.99407" stop-color="white" />
      </radialGradient>
      <radialGradient
        id="paint3_radial_410_32617"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(62.2907 35.8735) rotate(-158.764) scale(43.0283 40.8206)"
      >
        <stop stop-color="#EDF0F6" />
        <stop offset="1" stop-color="#FAFBFD" />
      </radialGradient>
      <radialGradient
        id="paint4_radial_410_32617"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(52.9756 69.8599) rotate(-108.519) scale(64.5959 51.4685)"
      >
        <stop stop-color="#A3B1D1" />
        <stop offset="0.714491" stop-color="white" />
      </radialGradient>
      <radialGradient
        id="paint5_radial_410_32617"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(36.8939 22.0263) rotate(76.7176) scale(15.8951 58.8485)"
      >
        <stop stop-color="#A3B1D1" />
        <stop offset="0.99407" stop-color="white" />
      </radialGradient>
      <radialGradient
        id="paint6_radial_410_32617"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(39.8756 31.419) rotate(-103.282) scale(15.8951 58.8485)"
      >
        <stop stop-color="#A3B1D1" />
        <stop offset="0.99407" stop-color="white" />
      </radialGradient>
      <radialGradient
        id="paint7_radial_410_32617"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(57.1564 11.5017) rotate(137.976) scale(41.4233 42.2944)"
      >
        <stop stop-color="#EDF0F6" />
        <stop offset="1" stop-color="#FAFBFD" />
      </radialGradient>
      <radialGradient
        id="paint8_radial_410_32617"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(40.5953 32.6825) rotate(-108.349) scale(25.4401 17.0174)"
      >
        <stop stop-color="#E7EBF2" />
        <stop offset="1" stop-color="#FAFBFD" />
      </radialGradient>
      <radialGradient
        id="paint9_radial_410_32617"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(44.4837 12.2716) rotate(127.574) scale(32.9378 11.8077)"
      >
        <stop stop-color="#A3B1D1" />
        <stop offset="1" stop-color="white" />
      </radialGradient>
    </defs>
  </svg>
</template>
